import React from "react";
import { withRouter } from "../_shared/withRouter";
import VerifyAccount from "../template/auth/verifyAccount";

const verifySuperAdmin = (props) => {
  return <VerifyAccount role={"1"} roleType={"superadmin"} />;
};

export default withRouter(verifySuperAdmin);
